import React, { useState } from "react";
import { Button, Box, Typography, Stack, Menu, Divider } from "@mui/material";
import QRCodeGenerator from "../componetns/QRCodeGen";
import PaymentForm from "./PaymentForm";
import theme from "../theme";
import { ThemeProvider } from "@mui/material/styles";
import { Tour } from "antd";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import "./css/antd.css";

const GuestMenu = ({
  leader,
  children,
  qrAnchorEl,
  setQrAnchorEl,
  qrOpen,
  sendComp,
  setSendComp,
  paymentLinks,
  tref1,
  tref2,
  tourOpen,
  setTourOpen,
}) => {
  const [selectedTab] = useState(0);
  const [paymentAnchorEl, setPaymentAnchorEl] = useState(null);
  const paymentMenuOpen = Boolean(paymentAnchorEl);

  const handleQRClick = (event) => {
    setPaymentAnchorEl(null);
    setQrAnchorEl(event.currentTarget);
  };

  const handleQRClose = () => {
    setQrAnchorEl(null);
    setSendComp(false);
  };

  const handlePaymentClick = (event) => {
    setQrAnchorEl(null);
    setPaymentAnchorEl(event.currentTarget); // ご祝儀用メニューを開く
  };

  const handlePaymentClose = () => {
    setPaymentAnchorEl(null); // ご祝儀用メニューを閉じる
  };

  if (sendComp) {
    // const buttonElement = document.getElementById("basic-button");
    // setQrAnchorEl(buttonElement);
  }

  const tourSteps = [
    {
      title: "ご祝儀の送金",
      description: "事前にご祝儀の送金が可能です",
      style: { fontFamily: "'KokuGothic', sans-serif" },
      target: () => tref2.current,
    },
    {
      title: "QRコードを表示",
      description: "当日はQRコードをご提示ください",
      style: { fontFamily: "'KokuGothic', sans-serif" },
      target: () => tref1.current,
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <div style={{ position: "relative", width: "100%" }}>
        <Stack
          direction="row"
          spacing={4}
          justifyContent="center"
          sx={{
            pt: 2,
            position: "fixed",
            width: "100%",
            maxWidth: "600px",
            top: "0px",
            left: "50%", // 画面中央に移動
            transform: "translateX(-50%)",
            zIndex: 1000,
            backgroundColor: "#fbf9f3",
          }}
        >
          <Button
            id="payment-button"
            aria-controls={paymentMenuOpen ? "payment-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={paymentMenuOpen ? "true" : undefined}
            onClick={handlePaymentClick} // ご祝儀用メニューを開く
            sx={{
              fontSize: "1.0rem",
            }}
            ref={tref2}
          >
            {paymentMenuOpen ? "閉じる" : "ご祝儀の送金"}
          </Button>

          <Button
            id="basic-button"
            aria-controls={qrOpen ? "qr-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={qrOpen ? "true" : undefined}
            onClick={handleQRClick}
            sx={{
              fontSize: "1.0rem",
            }}
            ref={tref1}
          >
            {qrOpen ? "閉じる" : "QRコードを表示"}
          </Button>
        </Stack>

        <Menu
          id="qr-menu"
          anchorEl={qrAnchorEl}
          open={qrOpen}
          onClose={handleQRClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <Box>
            {/* Tabs */}
            <Box sx={{ pt: 4, pl: 5, pr: 5, pb: 1 }}>
              <IconButton
                onClick={handleQRClose}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  color: "grey.600",
                }}
              >
                <CloseIcon />
              </IconButton>

              <Typography>
                当日は受付にてこちらのQRコードをご提示いただくとスムーズです
                <br />
                (お名前を口頭でお伝えいただいても大丈夫です)
              </Typography>
            </Box>

            {/* Tab Panels */}
            {leader.map((guest, index) => (
              <Box
                key={index}
                role="tabpanel"
                hidden={selectedTab !== index}
                id={`tabpanel-${index}`}
                aria-labelledby={`tab-${index}`}
                sx={{
                  p: 2,
                  backgroundColor: "white", // 背景を白に
                  borderRadius: 1, // 少し角を丸める
                }}
              >
                {selectedTab === index && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Stack>
                      <Box sx={{ p: 2 }}>
                        <QRCodeGenerator link={guest.id} />
                      </Box>

                      <Box sx={{ p: 1 }}></Box>

                      <Typography variant="body1">
                        名前： {guest.last_name} {guest.first_name}（
                        {guest.last_furigana} {guest.first_furigana}）
                      </Typography>

                      <Typography
                        variant="body1"
                        x={{ color: "#000000" }}
                        gutterBottom
                      >
                        アレルギー： {guest.allergy}
                      </Typography>

                      <Box sx={{ p: 1 }}></Box>

                      {(() => {
                        const hasYesGuests = guest.invited_guests?.some(
                          (child) => child.will === "yes"
                        );
                        const hasNoGuests = guest.invited_guests?.some(
                          (child) => child.will === "no"
                        );

                        return (
                          <>
                            {hasYesGuests && (
                              <Box sx={{ p: 1 }}>
                                <Divider>お連れ様</Divider>
                              </Box>
                            )}

                            {guest.invited_guests?.map(
                              (child, index) =>
                                child.will === "yes" && (
                                  <Stack key={`yes-${index}`} sx={{ pb: 1 }}>
                                    <Typography
                                      variant="body1"
                                      x={{ color: "#000000" }}
                                    >
                                      名前： {child.last_name}{" "}
                                      {child.first_name}（{child.last_furigana}{" "}
                                      {child.first_furigana}）
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                      アレルギー： {child.allergy}
                                    </Typography>
                                  </Stack>
                                )
                            )}

                            {hasNoGuests && (
                              <Box sx={{ p: 1 }}>
                                <Divider>ご欠席</Divider>
                              </Box>
                            )}

                            {guest.invited_guests?.map(
                              (child, index) =>
                                child.will === "no" && (
                                  <Stack key={`no-${index}`} sx={{ pb: 1 }}>
                                    <Typography
                                      variant="body1"
                                      x={{ color: "#000000" }}
                                    >
                                      名前： {child.last_name}{" "}
                                      {child.first_name}（{child.last_furigana}{" "}
                                      {child.first_furigana}）
                                    </Typography>
                                  </Stack>
                                )
                            )}
                          </>
                        );
                      })()}
                    </Stack>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Menu>

        <Menu
          id="payment-menu"
          anchorEl={paymentAnchorEl}
          open={paymentMenuOpen}
          onClose={handlePaymentClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <Box>
            <IconButton
              onClick={handlePaymentClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "grey.600",
              }}
            >
              <CloseIcon />
            </IconButton>

            <PaymentForm paymentLinks={paymentLinks} leader={leader} />
          </Box>
        </Menu>
      </div>

      {/* <Tour open={tourOpen} onClose={() => setTourOpen(false)} steps={tourSteps} /> */}
      <Tour
        open={tourOpen && tref1.current && tref2.current} // refがnullのときは表示しない
        onClose={() => setTourOpen(false)}
        steps={tourSteps}
      />
    </ThemeProvider>
  );
};

export default GuestMenu;
